import React, { useEffect, useMemo, useState } from 'react'
import { Button, Col, Form, message, Row, Table, UploadFile, Upload, Spin, Select, Input, notification, Modal } from "antd"
import { DeleteOutlined, InboxOutlined, UploadOutlined } from '@ant-design/icons'
import { addReference, addS3Reference, addSingleReference, deleteReference, getReference } from '../../api/Reference';
import Fuse from 'fuse.js'
import template from "../../assets/template ajout de reference.CSV"
import moment from 'moment'
import "./reference.css"
import { csvToJson } from '../Utils/csvToJson';
import ModalReference from './ModalReference';

const { Dragger } = Upload;
const { Option } = Select

const uploadLayout = {
  wrapperCol: { offset: 5, span: 18 },
}

function Reference() {
  const [update, setUpdate] = useState<boolean>(false)
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [dataSource, setDataSource] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [select, setSelect] = useState<string>("SKU")
  const [input, setInput] = useState<string>("")
  const [fuse, setFuse] = useState<any>(undefined)
  const [fuseSearch, setFuseSearch] = useState<any>(undefined)
  const [latestDate, setlatestDate] = useState<string | undefined>(undefined)
  const [modal, setModal] = useState<boolean>(false)
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false)
  const [deleteId, setDeleteId] = useState<null | string | undefined>(undefined)
  const [form] = Form.useForm();

  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    const list = await getReference()
    if (list.data && list.data.length > 0) {
      setlatestDate(moment(new Date(list.data[0].createdAt)).format("DD/MM/YYYY à HH:mm"))
      setDataSource(list.data)
      setFuse(new Fuse(list.data, { keys: [select], distance: 1, threshold: 0.0 }))
    } else {
      setDataSource([])
    }
  }

  const handlePopUp = () => {

  }

  const handleDelete = async (_id: string | null | undefined) => {
    if (!_id) return
    const res = await deleteReference(_id)
    getData()
    setDeleteOpen(false)
  }

  const column = [
    {
      title: 'Code Article (SKU)',
      dataIndex: 'SKU',
      key: 'BP',
      render: text => <span className='bold-text'>{text}</span>,
      width: 200,
    },
    {
      title: 'Libellé Court Article Français',
      dataIndex: 'shortWording',
      key: 'BP',
      render: text => <span className='bold-text'>{text}</span>,
      width: 400,
    },
    {
      title: 'Libellé Long Article Français',
      dataIndex: 'longWording',
      key: 'BP',
      render: text => <span className='bold-text'>{text}</span>,
    },
    {
      title: "Action",
      dataIndex: "_id",
      key: "action",
      render: (_id) => <Button icon={<DeleteOutlined />} onClick={() => {
        setDeleteOpen(true)
        setDeleteId(_id)
      }} />
    }
  ]

  const validateFileType = (
    { type, name }: UploadFile,
    allowedTypes?: string
  ) => {
    if (!allowedTypes) {
      return true;
    }

    if (type) {
      return allowedTypes.includes(type);
    }
  };

  useEffect(() => {
    setFuse(new Fuse(dataSource, { keys: [select], distance: 1, threshold: 0.0 }))
  }, [select])

  useEffect(() => {
    console.log(input)
    if (input.length === 0) return setFuseSearch(undefined)
    const res = fuse?.search(input)
    if (res) {
      let list = []
      list.push(res?.map((elem: { item: any }) => elem.item))
      setFuseSearch(list[0])
    }
  }, [input])

  const uploadProps = useMemo(
    () => ({
      beforeUpload: (file: UploadFile) => {
        const isAllowedType = validateFileType(file, "text/csv");
        if (!isAllowedType) {
          setFileList((state) => [...state]);
          message.error("Le fichier n'est pas au format CVS, veuillez réessayer");
          return false;
        }
        setFileList((state) => [...state, file]);
        return false;
      },
      onRemove: (file: UploadFile) => {
        if (fileList.some((item) => item.uid === file.uid)) {
          setFileList((fileList) =>
            fileList.filter((item) => item.uid !== file.uid)
          );
          return true;
        }
        return false;
      }
    }),
    [fileList]
  );

  const onFinish = async () => {
    const data = await new Promise<string[] | undefined>((resolve, reject) => {
      let list: any = []
      fileList.forEach((elem: any) => {
        let reader = new FileReader();
        if (reader) {
          reader.onload = ((event: any) => {
            list.push(event.target.result)
            if (list.length === fileList.length)
              resolve(list)
          })
          reader.readAsText(elem);
        }
      })
    })
    if (data) {
      setLoading(true)
      const json = csvToJson(data[0], ";")
      const res = await addReference(data)
      if (res?.data) {
        const s3 = await addS3Reference(json, "hiris_referential.json")
        const count = res.data.length
        setDataSource([...dataSource, ...res.data])
        message.success({ content: count + " références ont été aujoutés", duration: 10 })
        setFileList([])
        setUpdate(false)
        getData()
      } else if (res.response.status === 400 && res.response.data) {
        notification.error({ message: "Une erreur c'est produite", description: res.response.data, duration: 0 })
        setFileList([])
      }
      setLoading(false)
    }
  }

  const onFinishFailed = (errors: any) => {
  }

  const handleDownload = () => {
    const csvContent = "Code Article (SKU);Libellé Court Article Français;Libellé Long Article Français\nsku;label;label"
    var universalBOM = "\uFEFF";
    var a = window.document.createElement('a');
    a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + csvContent));
    a.setAttribute('download', "template_d'ajout_de_reference.CSV");
    window.document.body.appendChild(a);
    a.click();
  }

  const addOneReference = async (sku: string, shortWording: string, longWording: string) => {
    const res = await addSingleReference(sku, shortWording, longWording)
    if (res?.response?.status === 400 && res?.response?.data) {
      notification.error({ message: "Une erreur c'est produite", description: res.response.data, duration: 0 })
      return
    }
    var str = JSON.stringify([
      {
        "Code Article (SKU)": sku,
        "Libellé Court Article Français": shortWording,
        "Libellé Long Article Français": longWording
      }
    ])
    await addS3Reference(str, "hiris_referential.json")
    getData()
  }

  return (
    <div style={{ backgroundColor: "#f6f1eb" }}>
      <ModalReference modal={modal} setModal={setModal} add={addOneReference} />
      <Modal title={"Supprimer la référence"} open={deleteOpen} onOk={() => handleDelete(deleteId)} onCancel={() => setDeleteOpen(false)}
        footer={[
          <Button onClick={() => setDeleteOpen(false)}>Annuler</Button>,
          <Button style={{ backgroundColor: "red", color: 'white' }} onClick={() => handleDelete(deleteId)}>Supprimer</Button>
        ]}
      >
        Confirmez vous la suppression de la référence ?
      </Modal>
      <Row className='card-table'>
        {!update ?
          <>
            <Col xs={24} md={5}>
              <h1 style={{ paddingLeft: 0 }} className='reference-title'>Référentiel</h1>
              <span>{"Dernière mise à jour "}{latestDate?.toString()}</span>
            </Col>
            <Col xs={{ span: 20 }} md={5} >
              <div className='select-type'>
                <Select defaultValue={"SKU"} size='large' style={{ width: "100%" }} onChange={(e) => setSelect(e)}>
                  <Option value="SKU">Code Article (SKU)</Option>
                  <Option value="shortWording">Libellé Court Article Français	</Option>
                  <Option value="longWording">Libellé Long Article Français</Option>
                </Select>
              </div>
            </Col>
            <Col xs={{ span: 12 }} md={5} >
              <Input allowClear size='large' className='reference-input' onChange={(e) => setInput(e.target.value)} />
            </Col>
            <Col className='reference-update-col' xs={8} md={4} >
              <Button className="reference-add-button" size="large" onClick={() => setModal(true)}>
                Ajouter un article
              </Button>
            </Col>
            <Col className='reference-update-col' xs={8} md={4} >
              <Button className="reference-add-button" id="update-reference" style={{ marginLeft: "1rem" }} onClick={() => setUpdate(true)} size='large'>
                <UploadOutlined />
                Mettre à jour
              </Button>
            </Col>
            <Col xs={24}>
              <Table rowKey={(record) => record._id} columns={column} dataSource={fuseSearch ? fuseSearch : dataSource} />
            </Col>
          </>
          :
          <>
            <Col xs={24}>
              <h1 className='reference-title'>Ajouter plusieurs articles au référentiel</h1>
            </Col>
            <Col xs={24} className='reference-title'>
              <span style={{ fontSize: "1.2rem" }}>Vous pouvez ajouter plusieurs articles au référentiel d’un même coup en téléchargeant dans un premier temps le template, l’ouvrir avec l’éditeur de votre choix (Microsoft Excel, LibreOffice Calc, Numbers, …), le remplir avec les nouveaux articles et puis le déposer sur la zone et cliquer sur confirmer. Seuls les articles qui ne sont pas déjà présents dans le référentiel seront ajoutés.</span>
            </Col>
            <Col xs={24} className='reference-template-col'>
              <div className="template-bp-div">
                <a onClick={handleDownload}
                  id="download-reference-template"
                  style={{ textDecoration: "underline" }} download="template_d'ajout_de_reference.CSV" target='_blank' rel="noreferrer">
                  Telecharger un template
                </a>
              </div>
            </Col>
            <Col xs={24}>
              <Form
                form={form}
                name="basic"
                style={{ width: "85%" }}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 28 }}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                <Form.Item  {...uploadLayout}>
                  <Dragger customRequest={({ file, onSuccess }) => {
                    if (onSuccess) {
                      onSuccess("ok");
                    }
                  }} {...uploadProps} fileList={fileList}>
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Cliquer ou glisser un CSV dans cette zone</p>
                  </Dragger>
                </Form.Item>
                <div style={{ width: '100%', textAlign: 'center', position: "absolute" }}>
                  <Row style={{ width: '100%' }}>
                    <Col md={8} xs={0} />
                    <Col md={4} xs={24}>
                      <Button size='large' className="form-button reference-cancel-button" onClick={() => { setUpdate(false); setFileList([]) }}>Annuler</Button>
                    </Col>
                    <Col md={4} xs={24}>
                      <Spin spinning={loading} style={{ display: "inline" }}>
                        <Button size='large' className="form-button reference-add-button" htmlType="submit">
                          Confirmer
                        </Button>
                      </Spin>
                    </Col>
                    <Col md={8} xs={0} />
                  </Row>
                </div>
              </Form>
            </Col>
          </>
        }
      </Row>
    </div>
  )
}

export default Reference